import type { AgentAttributionTransactionMeta } from '@atlaskit/editor-common/transaction-agent-attribution';

import type { Suggestion } from '../../aiSuggestionsPluginType';

/** Older suggestions omit the agent profile, but their content is still AI-authored. */
export function getSuggestionAgentAttribution(
	suggestion: Suggestion,
): AgentAttributionTransactionMeta {
	return {
		agentId: suggestion.createdByAgent?.accountId || undefined,
		agentName: suggestion.createdByAgent?.name || undefined,
		agentType: suggestion.createdByAgent?.agentType || 'convo-ai',
	};
}
